module.exports = {
    search: {
        externalRedirectionDelay: 0,
        searchSuggestionThrottleTimeout: 500,
        zeroSearchResultsMessage: 'Your search term "{search}" returns no results',
        shouldRememberSort: false,
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/search.js